import React from 'react';
import { Link } from "react-router-dom";
import Logo from './Logo';
import useIsMobile from "../hooks/useIsMobile";

const Footer = ({ lang, translations }) => {
  const isDeviceMobile = useIsMobile();
  return (
    <div className='footer-container '>
      <div className='flex-column center'>
      <Logo img={"img/logos/faro_azul.png"} footer={true} alt={translations[lang].logoalt} />
      <div>
        <Link to="https://www.instagram.com/faro.castelldefels/" rel="nofollow" target="_blank" className='no-link'>
          <div className='flex padding-top2'>
            <img className="logo-instagram"  src="img/logos/instagram-vector.png" alt={translations[lang].instagramalt} />
            <p className="footer-text">@faro.castelldefels</p>
          </div>
        </Link>
      </div>
      <div>
      <div className="flex-column align-left">
      
        {/* Legal links */}

        {/* <div className="footer-section-titles">
          <h4>{translations[lang].legaltitle}</h4>
        </div>
        <div className={isDeviceMobile ? ('flex-column') : ('only-flex only-around')}>
          <p className={isDeviceMobile ? ('footer-text') : ("footer-text footer-left")}>{translations[lang].privacypolicy}</p>
          <p className="footer-text">{translations[lang].legalwarning}</p>
          <p className={isDeviceMobile ? ('footer-text'):("footer-text footer-right")}>{translations[lang].cookiespolicy}</p>
        </div> */}
        <div className={isDeviceMobile ? ('flex-column') : ('only-flex only-around')}>
          <p className="footer-year">2025</p>
        </div>
        <Link to="https://juanmiclavero.framer.website/" rel="nofollow" target="_blank" className='no-link'>
          <p className="footer-text">{translations[lang].designed}</p>
          </Link>
          <Link to="https://peremartinezibar.com" rel="nofollow" target="_blank" className='no-link'>
          <p className="footer-text">{translations[lang].developed}</p>
        </Link>
      </div>
      </div>

      </div>
   
    </div>
  );
};

export default Footer;
